(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Horizontal rails with previous / next buttons
  function initRail(section) {
    var rail = section.querySelector('[data-rail]');
    if (!rail || rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    var prev = section.querySelector('[data-rail-prev]');
    var next = section.querySelector('[data-rail-next]');
    var step = function () { return Math.max(260, rail.clientWidth * 0.8); };
    var sync = function () {
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    initAutoplay(section, rail);
  }

  // Auto slide: moves one card at a time, loops back to the start, and
  // pauses on hover, focus, touch, when off screen or when the shopper pauses it
  var ICON_PAUSE = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6v12M15 6v12"/></svg>';
  var ICON_PLAY = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5.5v13l11-6.5z"/></svg>';
  function initAutoplay(section, rail) {
    var delay = parseFloat(rail.dataset.autoplay) * 1000;
    if (!delay || reduce || rail.children.length < 2) return;
    var hover = false, focus = false, touch = false, stopped = false, inView = false, touchTimer = null;
    function step() {
      var first = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function tick() {
      if (hover || focus || touch || stopped || !inView || document.hidden) return;
      if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else rail.scrollBy({ left: step(), behavior: 'smooth' });
    }
    setInterval(tick, delay);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; }, { threshold: 0.35 }).observe(rail);
    } else { inView = true; }
    section.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    section.addEventListener('pointerleave', function () { hover = false; });
    rail.addEventListener('focusin', function () { focus = true; });
    rail.addEventListener('focusout', function () { focus = false; });
    rail.addEventListener('touchstart', function () { touch = true; clearTimeout(touchTimer); }, { passive: true });
    rail.addEventListener('touchend', function () { clearTimeout(touchTimer); touchTimer = setTimeout(function () { touch = false; }, 5000); }, { passive: true });
    var nav = section.querySelector('.rail-nav');
    if (nav) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rail-nav__btn rail-nav__toggle';
      function paint() {
        btn.innerHTML = stopped ? ICON_PLAY : ICON_PAUSE;
        btn.setAttribute('aria-label', stopped ? 'Play auto slide' : 'Pause auto slide');
        btn.setAttribute('aria-pressed', String(stopped));
      }
      btn.addEventListener('click', function () { stopped = !stopped; paint(); });
      paint();
      nav.insertBefore(btn, nav.firstChild);
    }
  }

  // Hero slideshow
  function initSlider(frame) {
    if (frame.dataset.sliderReady) return;
    frame.dataset.sliderReady = '1';
    var slides = frame.querySelectorAll('[data-slide]');
    var dots = frame.querySelectorAll('[data-dot]');
    if (slides.length < 2) return;
    var index = 0, timer = null, paused = false;
    function go(i) {
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      slides[index].setAttribute('tabindex', '-1');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides[index].removeAttribute('aria-hidden');
      slides[index].removeAttribute('tabindex');
      if (dots[index]) dots[index].classList.add('is-active');
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { if (!paused && !document.hidden) go(index + 1); }, 6000); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.dot, 10)); start(); }); });
    frame.addEventListener('mouseenter', function () { paused = true; });
    frame.addEventListener('mouseleave', function () { paused = false; });
    frame.addEventListener('focusin', function () { paused = true; });
    frame.addEventListener('focusout', function () { paused = false; });
    var x0 = null;
    frame.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
    });
    start();
  }

  // Sticky showcase: highlight the step in view and swap the pinned image
  function initShowcase(section) {
    if (section.dataset.showcaseReady) return;
    section.dataset.showcaseReady = '1';
    var steps = section.querySelectorAll('[data-showcase-step]');
    var imgs = section.querySelectorAll('[data-showcase-img]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = parseInt(e.target.dataset.showcaseStep, 10);
        steps.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        imgs.forEach(function (m, n) { m.classList.toggle('is-active', n === i); });
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach(function (s) { io.observe(s); });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.arail-section').forEach(initRail);
    scope.querySelectorAll('[data-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-showcase]').forEach(initShowcase);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slide]');
    if (slide) { var frame = slide.closest('[data-slider]'); var all = frame.querySelectorAll('[data-slide]'); var dot = frame.querySelectorAll('[data-dot]')[Array.prototype.indexOf.call(all, slide)]; if (dot) dot.click(); }
  });
})();
